import React from "react";
import ReactDOM from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import { initSentry } from "./lib/sentry";
import "./stores/themeStore"; // Initialize theme on load
import "./styles/globals.css";

// Initialize Sentry error tracking
initSentry();

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    console.info("New version available; updating now.");
    void updateSW(true);
  },
  onOfflineReady() {
    console.info("App ready to work offline.");
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
